import { collectionSizeOrNull1v5nsm81on7r9 as collectionSizeOrNull } from './Iterables.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from './LinkedHashSet.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from './collectionJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import {
  addAll1k27qatfgp3k5 as addAll,
  convertToListIfNotCollection2y7m25iq802o0 as convertToListIfNotCollection,
} from './MutableCollections.mjs';
import { toSet2orjxp16sotqu as toSet } from './_Collections.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { equals2au1ep9vhcato as equals } from '../js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function plus(_this__u8e3s4, elements) {
  var tmp0_safe_receiver = collectionSizeOrNull(elements);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = _this__u8e3s4.p1() + tmp0_safe_receiver | 0;
  }
  var tmp1_elvis_lhs = tmp;
  var result = LinkedHashSet().q(mapCapacity(tmp1_elvis_lhs == null ? imul(_this__u8e3s4.p1(), 2) : tmp1_elvis_lhs));
  result.r1(_this__u8e3s4);
  addAll(result, elements);
  return result;
}
function minus(_this__u8e3s4, elements) {
  var other = convertToListIfNotCollection(elements);
  if (other.i1())
    return toSet(_this__u8e3s4);
  if (isInterface(other, KtSet())) {
    // Inline function 'kotlin.collections.filterNotTo' call
    var destination = LinkedHashSet().v1();
    var _iterator__ex2g4s = _this__u8e3s4.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!other.t1(element)) {
        destination.v(element);
      }
    }
    return destination;
  }
  var result = LinkedHashSet().z1(_this__u8e3s4);
  result.w2(other);
  return result;
}
function plus_0(_this__u8e3s4, element) {
  var result = LinkedHashSet().q(mapCapacity(_this__u8e3s4.p1() + 1 | 0));
  result.r1(_this__u8e3s4);
  result.v(element);
  return result;
}
function minus_0(_this__u8e3s4, element) {
  var result = LinkedHashSet().q(mapCapacity(_this__u8e3s4.p1()));
  var removed = false;
  // Inline function 'kotlin.collections.filterTo' call
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element_0 = _iterator__ex2g4s.o1();
    var tmp;
    if (!removed && equals(element_0, element)) {
      removed = true;
      tmp = false;
    } else {
      tmp = true;
    }
    if (tmp) {
      result.v(element_0);
    }
  }
  return result;
}
//region block: exports
export {
  minus as minus165a8u1e0x1lu,
  minus_0 as minus27abgkurcn6u0,
  plus as plus1ogy4liedzq5j,
  plus_0 as plus18eogev54fmsa,
};
//endregion

//# sourceMappingURL=_Sets.mjs.map
